import { type FC } from "react";
import * as styles from "./styles.css";

export type FeatureStatus = "new" | "applied" | "keeping" | "considering" | "browsing";

const FeatureStatusText: Record<FeatureStatus, string> = {
  new: "NEW",
  applied: "応募済み",
  keeping: "キープ中",
  considering: "応募画面到達",
  browsing: "求人閲覧済",
};

type Props = {
  featureStatus: FeatureStatus;
};

export const FeatureStatusLabel: FC<Props> = ({ featureStatus }) => (
  <span className={styles.statusLabel[featureStatus]}>{FeatureStatusText[featureStatus]}</span>
);
